// ============================================================================
//  ACCESS CONTROL — EDIT THIS FILE
// ----------------------------------------------------------------------------
//  This is the only file Kabelo needs to touch to manage who gets in.
//  The gate is deliberately simple (per the build decision): an email on the
//  ALLOWLIST *plus* the shared PASSPHRASE. It keeps randoms out — it is NOT a
//  real identity system, so don't treat the passphrase as a secret that
//  protects money. Rotate it when someone leaves the ManCo.
//
//  HOW TO EDIT
//    1. PASSPHRASE — replace the placeholder below with the real shared phrase.
//    2. ALLOWLIST  — add/remove emails. Matching is case-insensitive.
//    3. ALLOW_DOMAINS — anyone with an email on these domains gets in with the
//       passphrase even if they aren't listed individually. Leave empty to
//       require every person to be on the ALLOWLIST explicitly.
//
//  Add new ManCo members below the existing list and delete entries when
//  someone leaves the program.
// ============================================================================

/**
 * The shared passphrase.
 *
 * !!! ROTATE BEFORE SHARING THE APP WITH THE MANCO !!!
 *
 * This is a working placeholder so the build is testable end-to-end. Replace
 * with the real Bvndle ManCo phrase before handing the .dmg to anyone.
 * Treat the passphrase like a meeting-room door code, not a vault key.
 */
export const PASSPHRASE = "3Vndle-M@nCo";

/**
 * Domains that are allowed with the passphrase even without an explicit
 * allowlist entry. Bvndle runs on the VFD Group tenant, so @vfdgroup.com is
 * the working "bvndle email". Add others (e.g. an external partner domain)
 * only if you mean to.
 */
export const ALLOW_DOMAINS: string[] = ["bvndle.com", "vfdgroup.com"];

/**
 * Explicit per-person allowlist. Useful for external collaborators who don't
 * sit on an allowed domain (e.g. Kabelo at KYL, Yinka at The Product Studio).
 *
 * Note: anyone on @bvndle.com or @vfdgroup.com is already allowed by the
 * domain rule above. The names below are listed individually anyway, so the
 * file is the program's roster — easy to audit, easy to revoke if someone
 * leaves.
 */
export const ALLOWLIST: string[] = [
  // — Bvndle ManCo (full roster, confirmed by Demilade · 2026-05-25) —
  "Ikechukwu@bvndle.com", // Bvndle MD
  "Ufuoma@bvndle.com", // HNI Loyalty / commercial
  "Elmer.aluge@bvndle.com", // BRF
  "Chibuzor@bvndle.com", // Yard / MTN Credit Vending
  "Demilade@bvndle.com", // ManCo coordinator
  "Rukiyat@bvndle.com", // Operations · BvndleGO
  "Ifedolapo@bvndle.com", // Marketing (Iffe)
  "Oluwasemiloore@bvndle.com", // Data lead (Akoni / Semilore)
  "Ibinye@bvndle.com", // Redemption
  "Williams@bvndle.com", // Merchants
  "Oluseyesj@bvndle.com", // LaaS (Seye)

  // — VFD Group EXCO / oversight —
  "Adaobi.Okerekeocha@vfdgroup.com", // EXCO · tech & product · tiebreaker
  "Samuel.Modupe@vfdgroup.com", // Group CISO
  "Gozie.Alozieuwa@vfdgroup.com", // ED Risk Management
  "Elochukwu.Eziechine@vfdgroup.com", // Investment & Business Performance

  // — External collaborators —
  "lehlongwanekabelo@gmail.com", // Kabelo · KYL · build
  "Yinka@theproductstudiohq.com", // The Product Studio HQ · research
  "Ayo.Tifase@blvcktech.com", // Blvck Tech · Windows tester (v0.7.3 trial)

  // — Still TODO —
  // "nonso@vfdgroup.com",  // chairman / sponsor · needs his actual address
];
